<template>
  <b-container>
    <Spinner size="32" message="Loading..." style="margin:0,auto" v-if="isLoading"></Spinner>
    <b-alert
        :show="showDismissibleAlert"
        dismissible
        @dismissed="showDismissibleAlert=false"
        :variant="variant"
    >{{alertText}}</b-alert>
    <b-table
      show-empty
      selectable
      select-mode="single"
      head-variant="dark"
      empty-text="No Claim available."
      stacked
      bordered
      striped
      :items="claims"
      :fields="fields"
      style="font-size:12px"
    >
      <template v-slot:cell(action)="row">
        <a target="_blank" :href="getImgUrl(row.item)">View</a>      
      </template>
    </b-table>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
export default {
  components: { Spinner },
  props: ["UserID"],
  data() {
    return {
      isLoading: false,
      alertText: "",
      showDismissibleAlert: false,
      variant: "danger",
      claims: [],
      fields: [
        { key: "LoanApplicationNo", label: "Application No", sortable: true },
        { key: "LOINumber", label: "LOI Number", sortable: true },
        {
          key: "LOIDate",
          label: "LOI Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "SanctionAmount", label: "Sanction Amount", sortable: true },
        { key: "LoanTenure", label: "Loan Tenure (months)", sortable: true },
        { key: "ROI", label: "Interest %", sortable: true },
        {
          key: "UpdatedDate",
          label: "Upload Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "LoanTenure", label: "Tenure Months" },
        { key: "BankName", label: "Bank Name" },
        { key: "BranchName", label: "Branch Name", sortable: true },
        {
          key: "DisbursementAmount",
          label: "Disbursement Amount",
          sortable: true
        },
        { key: "action", label: "View" }
      ]
    };
  },
  watch: {
    UserID: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getSanctionLetter();
      }
    }
  },
  methods: {
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.LoginID +
          "/" +
          pic.UploadSanctionLetter
        );
      }
    },
    getSanctionLetter() {
      this.isLoading = true;
      this.showDismissibleAlert = false;

      let promise = apis.ReadSanctionLetterQuery({ UserLoginID: this.UserID, RecordStartDate:'2000-01-01', RecordEndDate:'2099-12-31' });

      promise
        .then(response => {
          //console.log('SL', response);
          if (response.status == 200) {
            this.claims = response.body;
            this.totalRows = this.claims.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      //console.log(this.selectedDistrict);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/ClaimComponents/SanctionDetails.vue